<h1 mat-dialog-title>{{ 'Delete Virtual Machine' | translate }}</h1>
<div mat-dialog-content>
  <form [formGroup]="form">
    <ix-checkbox
      formControlName="zvols"
      [label]="'Delete Virtual Machine Data?' | translate"
      [tooltip]="helptext.delete_dialog.zvolsTooltip | translate"
    ></ix-checkbox>
    <ix-checkbox
      formControlName="force"
      [label]="'Force Delete?' | translate"
      [tooltip]="helptext.delete_dialog.forceTooltip | translate"
    ></ix-checkbox>
    <ix-input
      formControlName="confirmName"
      [label]="'Enter {value} below to confirm.' | translate: { value: vm.name }"
      [required]="true"
    ></ix-input>
  </form>
</div>
<mat-dialog-actions>
  <ix-form-actions>
    <button
      mat-button
      ixTest="cancel"
      [matDialogClose]="false"
    >
      {{ 'Cancel' | translate }}
    </button>
    <button
      *ixRequiresRoles="requiredRoles"
      mat-button
      color="primary"
      ixTest="delete"
      [disabled]="form.invalid"
      (click)="onDelete()"
    >
      {{ 'Delete' | translate }}
    </button>
  </ix-form-actions>
</mat-dialog-actions>
